import React from 'react'
import { Link, NavLink } from 'react-static'
import PropTypes from 'prop-types'

import { scrollToTop } from '../helpers'

import logo from '../images/logo-horizontal-white.png'
import phone from '../images/icons/telephone.png'
import location from '../images/icons/pin-white.png'
import envelope from '../images/icons/envelope.png'

const Footer = props => (
  <footer className="relative">
    <div className="footer-inner">
      <div className="footer-top">
        <div className="footer-top__block">
          <div className="footer-top__logo">
            { props.homeLink
              ? <Link to="/">
                <img src={logo} alt="Makuch Roofing" />
              </Link>
              : <img src={logo} alt="Makuch Roofing" onClick={scrollToTop} />
            }
          </div>
        </div>
        <div className="footer-top__block">
          <div className="footer-top__block-box">
            <NavLink exact to="/" activeClassName="active">Home</NavLink>
            <span>|</span>
            <NavLink to="/blog" activeClassName="active">Blog</NavLink>
            <span>|</span>
            <NavLink to="/contact" activeClassName="active">Contact</NavLink>
          </div>
          <div className="footer-top__block-box">
            <p><img src={envelope} alt="email" />jonathan@makuchroofing.co.nz</p>
            <p><img src={phone} alt="phone" />0274 284 027</p>
            <p><img src={location} alt="location" />187 Kihikihi Road, Te Awamutu, 3800</p>
          </div>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      <p>© 2013-2017 Makuch Roofing Ltd</p>
      <a href="https://www.contentful.com/" rel="noopener noreferrer" target="_blank"><img src="https://images.contentful.com/fo9twyrwpveg/7Htleo27dKYua8gio8UEUy/0797152a2d2f8e41db49ecbf1ccffdaa/PoweredByContentful_DarkBackground_MonochromeLogo.svg" style={{ maxWidth: '100px', width: '100%' }} alt="Powered by Contentful" /></a>
    </div>
  </footer>
)

Footer.propTypes = {
  homeLink: PropTypes.bool,
}

export default Footer



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Footer.js